import { combineReducers } from "redux";
import all_share_booking from "../features/admin/share_booking/all_booking/slice";

const share_bookingmanagement = combineReducers({
  all_share_booking: all_share_booking,
});

export default share_bookingmanagement;
